import { Swiper } from 'swiper';
import { Navigation, Pagination, Controller } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';
import { classInstance } from '@/shared/helpers/helpers';

export class MainCollectionsDoctors {
	private readonly element: HTMLElement;
	private buttonPrev: HTMLElement;
	private buttonNext: HTMLElement;
	private paginationElement: HTMLElement;
	private slider: Swiper;
	private readonly collection: Swiper;
	private readonly navigation: HTMLElement;

	private sliderSettings = (): SwiperOptions => ({
		modules: [Navigation, Pagination, Controller],
		slidesPerView: 1,
		navigation: {
			prevEl: this.buttonPrev,
			nextEl: this.buttonNext,
		},
		pagination: {
			el: this.paginationElement,
			type: 'progressbar',
		},
		controller: {
			control: this.collection,
		},
	});


	constructor({ element, collection, navigation }) {
		if (!element) return;
		this.element = element;
		this.collection = collection;
		this.navigation = navigation;
		this.init();
	}

	public init = (): void => {
		this.buttonPrev = this.navigation.querySelector('.slider-navigation__button--prev');
		this.buttonNext = this.navigation.querySelector('.slider-navigation__button--next');
		this.paginationElement = this.navigation.querySelector('.slider-navigation__pagination');
		this.slider = new Swiper(this.element, this.sliderSettings());
		classInstance.set(this.element, this);
		console.log(this);
	};

	public destroy = (): void => {
		classInstance.del(this, 'MainCollectionsDoctors');
		this.slider.destroy();
		this.buttonPrev = null;
		this.buttonNext = null;
		this.paginationElement = null;
		this.slider = null;
	};
}
